import { render, staticRenderFns } from "./BalanceInfo.vue?vue&type=template&id=1cb95279&scoped=true&"
import script from "./BalanceInfo.vue?vue&type=script&lang=js&"
export * from "./BalanceInfo.vue?vue&type=script&lang=js&"
import style0 from "./BalanceInfo.vue?vue&type=style&index=0&id=1cb95279&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb95279",
  null
  
)

export default component.exports